import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { WebStorage, WebStorageNames } from "../../utils";

class NotFound extends Component {
  render() {
    const isLoggedIn = WebStorage.getLocalStore(WebStorageNames.UserLoggedIn);
    return <Redirect to={isLoggedIn ? "/dashboard" : "/register"} />;
  }
}

export default NotFound;
